import * as Sentry from '@sentry/react'

export const SENTRY_INTEGRATIONS = [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false
    }),
    Sentry.httpClientIntegration()
]

const IGNORED_ERROR_PATTERNS: RegExp[] = [
    /ResizeObserver loop/i,
    /Non-Error promise rejection/,
    /SendbirdError/,
    /Connection is required/
]

export function isRelevantError(event: Sentry.ErrorEvent): boolean {
    if (event.exception?.values) {
        const hasIgnoredError = event.exception.values.some((exception) => {
            const errorType = exception.type || ''
            const errorValue = exception.value || ''
            return IGNORED_ERROR_PATTERNS.some(
                (pattern) => pattern.test(errorType) || pattern.test(errorValue)
            )
        })

        if (hasIgnoredError) {
            return false
        }
    }

    return true
}

interface CaptureSentryErrorParams {
    name: string
    description: string
    fingerprint?: string[]
    extra?: Record<string, unknown>
    tags?: Record<string, string>
    error?: unknown
}

export function captureSentryError(params: CaptureSentryErrorParams): Promise<boolean> {
    const {name, description, fingerprint, extra, tags, error} = params
    const customError = new Error(description)
    customError.name = name

    if (error instanceof Error && error.stack) {
        customError.stack = error.stack
    }

    Sentry.captureException(customError, {
        fingerprint,
        extra: {
            ...extra,
            originalError: error
        },
        tags
    })

    return Sentry.flush(2000)
}

export function getErrorMessage(error: unknown, fallback: string): string {
    if (error instanceof Error) return error.message
    if (typeof error === 'string') return error
    return fallback
}
